
const STORAGE_KEY = 'truthbrush_cart'
const STORAGE_KEY_COUPONID = 'truthbrush_coupon_id'
const STORAGE_KEY_KIOSKID = 'truthbrush_kiosk_id'
const STORAGE_KEY_KIOSKID_TIME = 'truthbrush_kiosk_id_time'
const KIOSK_SKU_ID = "sku_kiosk_free_shipping"
const PROMOTION_POP_KEY = "truthbrush_promotion_pop"
const PIXELID = "363642587964125"

import { submitOrderInfo, submitNewOrder, captureOrderToken, getSKUList, getCoupon, sendEmailReceipt } from '../api/store.js'
import store from '../store'


export default {

  freeskinname() {
    return "";
  },

  reportAddCart() {
    window.fbq("track", "AddToCart");
    //window.ttq.track('AddToCart')
    //window.snaptr('track', 'ADD_CART');
    //window.gtag('event', 'conversion', { 'send_to': 'AW-610560568/IOUjCPzNj6cDELjUkaMC' });
    console.log("report addcart")
  },

  reportInitCheckout(_value) {
    window.fbq("track", "InitiateCheckout", {
      currency: "USD",
      value: _value,
    });

    //window.gtag('event', 'conversion', { 'send_to': 'AW-610560568/k-dNCPuuyacDELjUkaMC' });
    //window.ttq.track('InitiateCheckout')
    //window.snaptr('track', 'START_CHECKOUT');
    console.log("report checkout")
  },

  reportAddPayment() {
    window.fbq('track', 'AddPaymentInfo');
    //window.ttq.track('AddPaymentInfo')
    //window.snaptr('track', 'ADD_BILLING');
    console.log("report paymentinfo")
  },

  reportPurchase(_value) {
    //console.log("purchase:"+ _value)
    window.fbq("track", "Purchase", {
      currency: "USD",
      value: _value,
    });
    /*
    window.gtag('event', 'conversion', {
      'send_to': 'AW-610560568/tcPtCM-ExqcDELjUkaMC',
      'transaction_id': ''
    });
    window.ttq.track('PlaceAnOrder')
    window.ttq.track('CompletePayment')
    */
    //window.snaptr('track', 'PURCHASE');
    console.log("report purchase")
  },

  initExtended(_em, _fn, _ln, _ph, _ct, _st, _zp, _cty){
    if(_em!=null){
      _em = _em.toLowerCase()
    }
    /*
    console.log(_em);
    console.log(_fn);
    console.log(_ln);
    console.log(_ph);
    console.log(_ct);
    console.log(_st);
    console.log(_zp);
    console.log(_cty);
    */
    
    window.fbq('init', PIXELID, {
      em: _em,
      fn: _fn,    
      ln: _ln,
      ph: _ph,
      ct: _ct,
      st: _st,
      zp: _zp,
      country: _cty
    });

    console.log("init:"+_em+" "+_fn)
  },

  reportViewContent() {
    window.fbq("track", "reportViewContent");
    /*
    window.gtag('event', 'conversion', {
      'send_to': 'AW-610560568/tcPtCM-ExqcDELjUkaMC',
      'transaction_id': ''
    });
    */
    //window.ttq.track('ViewContent')
    //window.snaptr('track', 'PURCHASE');
    console.log("report purchase")
  },


  clearCart() {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(null));
    this.clearstorestate();
  },

  getCart() {
    return JSON.parse(localStorage.getItem(STORAGE_KEY));
  },

  getPromotionPop(){
    return localStorage.getItem(PROMOTION_POP_KEY);
  },
  savePromotionPop() {
    localStorage.setItem(PROMOTION_POP_KEY, (new Date()).getTime());
  },

  getCoupon() {
    console.log('read coupon:' + JSON.parse(sessionStorage.getItem(STORAGE_KEY_COUPONID)))
    return JSON.parse(sessionStorage.getItem(STORAGE_KEY_COUPONID));
  },
  saveCoupon(couponid) {
    sessionStorage.setItem(STORAGE_KEY_COUPONID, JSON.stringify(couponid));
    console.log('save coupon:' + couponid)
  },

  getKiosk() {
    console.log('read kiosk:' + JSON.parse(sessionStorage.getItem(STORAGE_KEY_KIOSKID)))
    var then = JSON.parse(sessionStorage.getItem(STORAGE_KEY_KIOSKID_TIME));
    var thenTime = new Date(then);
    var now = new Date();
    console.log("tiem check: then:"+(then/1000)+" now:"+(now.getTime()/1000)+" Kiosk="+(now.getTime() - thenTime <= 3600 * 1000))
    if(now.getTime() - thenTime > 3600 * 1000){ 
      return null;
    }
    return JSON.parse(sessionStorage.getItem(STORAGE_KEY_KIOSKID));
  },
  saveKiosk(kioskid) {
    var now = new Date();
    sessionStorage.setItem(STORAGE_KEY_KIOSKID, JSON.stringify(kioskid));
    sessionStorage.setItem(STORAGE_KEY_KIOSKID_TIME, now.getTime());

    
    console.log('save kiosk:' + kioskid)
  },
  shuffleArray(array) {
    for (var i = array.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var temp = array[i];
      array[i] = array[j];
      array[j] = temp;
    }
  },

  getSkuName() {
    if (store.state.selectedindex < store.state.skulist4display.length) {
      var obj = store.state.skulist4display[store.state.selectedindex];
      if (obj.productid == "prod_0002") store.state.skuname = "Hub";
      if (obj.productid == "prod_0001") store.state.skuname = "Tracker";
      if (obj.productid == "prod_0003") store.state.skuname = "Pro";
    }
  },
  getSKUPrice(isdiscount) {
    if (store.state.selectedindex < store.state.skulist4display.length) {
      if (!isdiscount) {
        store.state.skuprice = store.state.skulist4display[store.state.selectedindex].price / 100;
      } else {
        store.state.skuprice = (
          (store.state.skulist4display[store.state.selectedindex].price *
            (1 - store.state.discount_percent)) /
          100
        ).toFixed(2);
      }
    }
  },

  processKiosk() {
    var context = this;
    var kioskid = null;
    var parts = window.location.href.split("kiosk?id=");
    if (parts.length > 1) {
      var str = parts[1].trim();
      let arr = [];
      arr.push(str.indexOf('&'));
      arr.push(str.indexOf('?'));
      arr.push(str.indexOf('#'));
      arr.push(str.indexOf('/'));
      let max = str.length;
      let i = 0;
      for (; i < arr.length; i++) {
        if (arr[i] >= 0 && arr[i] < max) {
          max = arr[i];
        }
      }

      kioskid = str.substring(0, max);
      if(kioskid!=null && kioskid.length!=0){
        context.saveKiosk(kioskid)
      }
      var couponid = kioskid;

      if (couponid != null) {
        getCoupon(couponid)
          .then((res) => {
            //alert('coupon downloaded:'+res.data.valid)
            var coupon = res.data;
            if (coupon.valid) {
              //alert('coupon save:'+couponid)
              store.state.couponid = coupon.id;
              context.saveCoupon(coupon.id);
  
              if (coupon.percentOff != null) {
                store.state.discount_percent = coupon.percentOff / 100.0;
              } else if (coupon.amountoff != null) {
                store.state.discount_amount = coupon.amountoff;
              }
              context.updatePrice();
            } else {
              context.saveCoupon(null);
              store.state.discount_percent = 0;
              store.state.discount_amount = 0;
              store.state.couponid = null;
            }
          })
          .catch(function (err) {
            console.log(JSON.stringify(err))
            context.saveCoupon(null);
            store.state.discount_percent = 0;
            store.state.discount_amount = 0;
            store.state.couponid = null;
          });
      }
    }
  },
  processCoupon() {
    var context = this;
    var couponid = null;
    var parts = window.location.href.split("coupon=");
    if (parts.length > 1) {
      var str = parts[1].trim();
      let arr = [];
      arr.push(str.indexOf('&'));
      arr.push(str.indexOf('?'));
      arr.push(str.indexOf('#'));
      arr.push(str.indexOf('/'));
      let max = str.length;
      let i = 0;
      for (; i < arr.length; i++) {
        if (arr[i] >= 0 && arr[i] < max) {
          max = arr[i];
        }
      }

      couponid = str.substring(0, max);
    }
    //alert('couponid entered:'+couponid)
    if (couponid == null) {
      couponid = this.getCoupon();
      //alert('couponid read:'+couponid)

      // default 10% off?
      if (couponid == null) {
        couponid = "dV7sL3vU";
      }
    }

    if (couponid == 'babysideburns') {
      //couponid = 'A3KzVdj8';
    }

    if (couponid != null) {
      getCoupon(couponid)
        .then((res) => {
          //alert('coupon downloaded:'+res.data.valid)
          var coupon = res.data;
          if (coupon.valid) {
            //alert('coupon save:'+couponid)
            store.state.couponid = coupon.id;
            context.saveCoupon(coupon.id);

            if (coupon.percentOff != null) {
              store.state.discount_percent = coupon.percentOff / 100.0;
            } else if (coupon.amountoff != null) {
              store.state.discount_amount = coupon.amountoff;
            }
            context.updatePrice();
          } else {
            context.saveCoupon(null);
            store.state.discount_percent = 0;
            store.state.discount_amount = 0;
            store.state.couponid = null;
          }
        })
        .catch(function (err) {
          console.log(JSON.stringify(err))
          context.saveCoupon(null);
          store.state.discount_percent = 0;
          store.state.discount_amount = 0;
          store.state.couponid = null;
        });
    }
    return couponid
  },
  hoversample(index) {
    store.state.hoverindex = index;
    this.selectedimage();
  },
  selectedimage(isskin) {
    if (isskin == null || isskin == false) {
      if (store.state.imagelist.length > 0) {
        return store.state.imagelist[2];
      }
    } else {
      //console.log(store.state.imagelistskin)
      return store.state.imagelistskin
    }
  },

  getStockSKU(sku) {
    console.log(sku.inventory)
    if (sku == null || sku.inventory == null || sku.inventory.type == "infinite") {
      store.state.stock = 99999;
    } else {
      store.state.stock = parseInt(sku.inventory.quantity);
    }
  },

  setUnderline(index, val) {
    store.state.extrasensorclass = [false, false, false, false, false, false, false];
    store.state.extrasensorclass[index] = val;
  },

  clearstorestate() {
    store.state.skulist = []; //list of raw skus (tracker, pro and hubs)
    store.state.skinskulist = []; //list of raw skin skus
    store.state.skulist4display = []; // list of skus for home page only
    store.state.imagelist = []; // list of images for a selected shopping page
    store.state.selectedindex = 0;
    store.state.hoverindex = 0;
    store.state.extrasensorclass = [false, false, false, false, false, false, false];
    store.state.discount_percent = 0;
    store.state.discount_amount = 0;
    store.state.stock = 99999;
    store.state.cartlength = 0;
    store.state.skuquantitylist.selectedsku = [];
    store.state.couponid = null;
  },

  clicksku(index, isskin) {
    if (isskin == null || !isskin) {
      store.state.selectedindex = index;
      var sku = store.state.skulist4display[index];
      store.state.imagelist = [];
      if (sku != null && sku.metadata != null) {
        store.state.imagelist.push(sku.metadata.image2);
        store.state.imagelist.push(sku.metadata.image0);
        store.state.imagelist.push(sku.metadata.image1);
      }
      this.hoversample(0);
      this.getStockSKU(sku);
    } else {
      store.state.selectedindex = index;
      sku = store.state.skinskulist[index];
      store.state.imagelistskin = [];
      if (sku != null) {
        store.state.imagelistskin = sku.images;
      }
      this.hoversample(0);
      this.getStockSKU(sku);
    }
  },

  updatePrice() {
    var isDiscount = false;
    if (store.state.discount_percent > 0 || store.state.discount_amount > 0) {
      isDiscount = true;
    }
    this.getSkuName();
    this.getSKUPrice(isDiscount);
  },

  populateSku(page, index) {
    //page.show = true;
    // skins
    //var context = this;


    var targetid = "prod_Hef7TlYHGOPiXA"; //prod

    //targetid = "prod_HbGy06UPTMbY0P"; //dev
    getSKUList(targetid)
      .then((res) => {
        if (res != null) {
          page.show = false;
          for (var i = 0; i < res.data.length; i++) {
            store.state.price_tracker = res.data[0].price;
            var obj = res.data[i];
            obj.productid = "prod_0001";
            obj.productname = "Truthbrush Tracker w 6 Months Built-in Battery";
            store.state.skulist.unshift(obj);
            store.state.skulist4display.unshift(obj);
          }
          if (index == 0) {
            page.clicksku(0);
          }
          this.updatePrice();
        }
      })
      .catch(function () {
        page.show = false;
      });

    /*
  targetid = "prod_JNKB4cEFcpK5kj";

  getSKUList(targetid)
    .then((res) => {
      if (res != null) {
        page.show = false;
        for (var i = 0; i < res.data.length; i++) {
          store.state.price_tracker_pro = res.data[0].price;
          store.state.tracker_pro_sku = res.data[0];
          var obj = res.data[i];
          obj.productid = "prod_0003";
          obj.productname = "Truthbrush Tracker Pro" + context.freeskinname();
          store.state.skulist.push(obj);
          store.state.skulist4display.push(obj);
        }

        if (index == 2) {
          page.clicksku(0);
        }
        this.updatePrice();
      }
    })
    .catch(function (err) {
      console.log(err);
      page.show = false;
    });
    */

    targetid = "prod_Hef17phAPkhGTv"; //prod

    //targetid = "prod_HbHergnSUeV0dL"; //dev
    getSKUList(targetid)
      .then((res) => {
        if (res != null) {
          page.show = false;
          for (var i = 0; i < res.data.length; i++) {
            store.state.price_hub = res.data[0].price;
            var obj = res.data[i];
            obj.productid = "prod_0002";
            obj.productname = "Truthbrush Hub";
            store.state.hub_sku = obj;
            store.state.skulist.push(obj);
            //context.skulist4display.push(obj);
          }

          //this.clicksku(0, false);
          this.updatePrice();
        }
      })
      .catch(function () {
        page.show = false;
      });

    /*
  var targetid = "prod_JYDyFeiF7mLBfg";

  getSKUList(targetid)
    .then((res) => {

      if (res != null) {
        page.show = false;
        for (var i = 0; i < res.data.length; i++) {
          store.state.price_skin = res.data[0].price;
          var obj = res.data[i];
          obj.productid = "prod_0000";
          obj.productname = "Truthbrush Skin";
          store.state.skinskulist.push(obj);
        }
        context.shuffleArray(store.state.skinskulist);
        if (index == 1) {
          context.clicksku(0, true);
        }
      }
    })
    .catch(function () {
      page.show = false;
    });
*/
    targetid = "prod_GNK5iq2BisA6sX" // tracker 1 year battery
    //targetid = "prod_HbGy06UPTMbY0P"; //dev
    getSKUList(targetid)
      .then((res) => {
        if (res != null) {
          page.show = false;
          for (var i = 0; i < res.data.length; i++) {
            store.state.price_tracker = res.data[0].price;
            var obj = res.data[i];
            obj.productid = "prod_0004";
            obj.productname = "Truthbrush Tracker w 1 Year Extended Battery";
            store.state.skulist.unshift(obj);
          }
          if (index == 0) {
            page.clicksku(0);
          }
          this.updatePrice();
        }
      })
      .catch(function () {
        page.show = false;
      });

  },

  inseirtSku_Quantity_to_Store(sku, quantity) {
    var found = false;
    for (var i = 0;
      store.state.skuquantitylist != null
      && store.state.skuquantitylist.selectedsku != null
      && i < store.state.skuquantitylist.selectedsku.length; i++) {
      if (store.state.skuquantitylist.selectedsku[i].sku.id == sku.id) {
        store.state.skuquantitylist.selectedsku[i].quantity += quantity;
        found = true;
        break;
      }
    }
    if (!found) {
      store.state.skuquantitylist.selectedsku.push({ sku: sku, quantity: quantity });
    }
    this.updatecartlen()
  },

  speelplural(q, word) {
    if (q <= 1) {
      return word;
    } else {
      return word + "s";
    }
  },
  getproductname() {
    var tracker = 0;
    var trackerpro = 0;
    var hub = 0;
    for (
      var i = 0;
      store.state.skuquantitylist.selectedsku != null &&
      i < store.state.skuquantitylist.selectedsku.length;
      i++
    ) {
      if (
        store.state.skuquantitylist.selectedsku[i].sku.productid ==
        "prod_0001" || store.state.skuquantitylist.selectedsku[i].sku.productid ==
        "prod_0004"
      ) {
        tracker += store.state.skuquantitylist.selectedsku[i].quantity;
      } else if (
        store.state.skuquantitylist.selectedsku[i].sku.productid ==
        "prod_0003"
      ) {
        trackerpro += store.state.skuquantitylist.selectedsku[i].quantity;
      } else if (
        store.state.skuquantitylist.selectedsku[i].sku.productid ==
        "prod_0002"
      ) {
        hub += store.state.skuquantitylist.selectedsku[i].quantity;
      }
    }

    var productname = "";
    if (tracker != 0) {
      productname += tracker + this.speelplural(tracker, " Tracker") + ". ";
    }

    if (trackerpro != 0) {
      productname +=
        trackerpro + this.speelplural(trackerpro, " Tracker Pro" + this.freeskinname()) + ". ";
    }

    if (hub != 0) {
      productname += hub + this.speelplural(hub, " Hub") + ". ";
    }

    if (hub > 0 && (tracker > 0 || trackerpro > 0))
      productname += " Ready to use.";
    return productname;
  },
  deletesku_from_store(sku) {
    var list = [];
    for (var i = 0;
      store.state.skuquantitylist != null
      && store.state.skuquantitylist.selectedsku != null
      && i < store.state.skuquantitylist.selectedsku.length; i++) {
      if (store.state.skuquantitylist.selectedsku[i].sku.id != sku.id) {
        list.push(store.state.skuquantitylist.selectedsku[i]);
      }
    }
    store.state.skuquantitylist.selectedsku = list;
    this.updatecartlen()
  },
  updatecartlen() {
    var len = 0;
    for (var i = 0;
      store.state.skuquantitylist != null
      && store.state.skuquantitylist.selectedsku != null
      && i < store.state.skuquantitylist.selectedsku.length; i++) {
      len += store.state.skuquantitylist.selectedsku[i].quantity;
    }
    store.state.cartlength = len;
  },
  is_subscription_item_in_cart(){
    for (var j = 0;
      store.state.skuquantitylist != null
      && store.state.skuquantitylist.selectedsku != null
      && j < store.state.skuquantitylist.selectedsku.length; j++) {
        //console.log(store.state.skuquantitylist.selectedsku[j].sku.id)
      if (store.state.skuquantitylist.selectedsku[j].sku.id.includes("sku_activation_")) {
        return true;
      }
    }
    return false;
  },
  onAddCart(list, page, noExpressCheckout) {

    this.reportAddCart();
   
    for (var i = 0; i < list.length; i++) {
      var obj = list[i]
      this.inseirtSku_Quantity_to_Store(obj.sku, obj.quantity);
    }

    this.saveStore2Cart()
    if(noExpressCheckout){
      return;
    }
    setTimeout(function () {
      page.show = false;
    }, 500);
    //this.updateInfo();
    page.$refs["my-modal"].showExpressCheckout();
    var context = this;
    setTimeout(function () {
      if(!(context.is_subscription_item_in_cart())){
        const element = page.$refs["my-modal"].getPaypalButton();
        context.updatePayPayButton(element, page);
      }
      const elementstripe = page.$refs["my-modal"].getStripeButton();
      context.updateStripeButton(elementstripe, page);
    }, 500);

  },
  saveStore2Cart() {
    var cart = JSON.parse(localStorage.getItem(STORAGE_KEY));
    if (store.state.skuquantitylist == null || store.state.skuquantitylist.selectedsku == []) {
      return;
    }
    if (cart == null) {
      cart = {};
    }

    cart.selectedsku = store.state.skuquantitylist.selectedsku;
    localStorage.setItem(STORAGE_KEY, JSON.stringify(cart));
  },

  saveCart2Store(page) {
    var cart = JSON.parse(localStorage.getItem(STORAGE_KEY));
    var context = this;
    setTimeout(function () {
      if (page.$store.state.skuquantitylist.selectedsku.length == 0 && cart != null) {
        page.$store.state.skuquantitylist = cart;
      }
      context.updatecartlen();
    }, 500);

  },

  calculatetax(state, total) {
    var rate = 0;
    if (state == 'Alabama' || state == 'AL') {
      rate = 0.04;
    } else if (state == 'Alaska' || state == 'AK') {
      rate = 0.00;
    } else if (state == 'Arizona' || state == 'AZ') {
      rate = 0.056;
    } else if (state == 'Arkansas' || state == 'AR') {
      rate = 0.065;
    } else if (state == 'California' || state == 'CA') {
      rate = 0.0725;
    } else if (state == 'Colorado' || state == 'CO') {
      rate = 0.029;
    } else if (state == 'Connecticut' || state == 'CT') {
      rate = 0.0635;
    } else if (state == 'Delaware' || state == 'DE') {
      rate = 0.00;
    } else if (state == 'District Of Columbia' || state == 'DC') {
      rate = 0.06;
    } else if (state == 'Florida' || state == 'FL') {
      rate = 0.06;
    } else if (state == 'Georgia' || state == 'GA') {
      rate = 0.04;
    } else if (state == 'Guam' || state == 'GU') {
      rate = 0.04;
    } else if (state == 'Hawaii' || state == 'HI') {
      rate = 0.04166;
    } else if (state == 'Idaho' || state == 'ID') {
      rate = 0.06;
    } else if (state == 'Illinois' || state == 'IL') {
      rate = 0.0625;
    } else if (state == 'Indiana' || state == 'IN') {
      rate = 0.07;
    } else if (state == 'Iowa' || state == 'IA') {
      rate = 0.06;
    } else if (state == 'Kansas' || state == 'KS') {
      rate = 0.065;
    } else if (state == 'Kentucky' || state == 'KY') {
      rate = 0.06;
    } else if (state == 'Louisiana' || state == 'LA') {
      rate = 0.0445;
    } else if (state == 'Maine' || state == 'ME') {
      rate = 0.055;
    } else if (state == 'Maryland' || state == 'MD') {
      rate = 0.06;
    } else if (state == 'Massachusetts' || state == 'MA') {
      rate = 0.0625;
    } else if (state == 'Michigan' || state == 'MI') {
      rate = 0.06;
    } else if (state == 'Minnesota' || state == 'MN') {
      rate = 0.06875;
    } else if (state == 'Mississippi' || state == 'MS') {
      rate = 0.07;
    } else if (state == 'Missouri' || state == 'MO') {
      rate = 0.04225;
    } else if (state == 'Montana' || state == 'MT') {
      rate = 0.00;
    } else if (state == 'Nebraska' || state == 'NE') {
      rate = 0.055;
    } else if (state == 'Nevada' || state == 'NV') {
      rate = 0.0685;
    } else if (state == 'New Hampshire' || state == 'NH') {
      rate = 0.00;
    } else if (state == 'New Jersey' || state == 'NJ') {
      rate = 0.06625;
    } else if (state == 'New Mexico' || state == 'NM') {
      rate = 0.05125;
    } else if (state == 'New York' || state == 'NY') {
      rate = 0.04;
    } else if (state == 'North Carolina' || state == 'NC') {
      rate = 0.0475;
    } else if (state == 'North Dakota' || state == 'ND') {
      rate = 0.05;
    } else if (state == 'Ohio' || state == 'OH') {
      rate = 0.0575;
    } else if (state == 'Oklahoma' || state == 'OK') {
      rate = 0.045;
    } else if (state == 'Oregon' || state == 'OR') {
      rate = 0.00;
    } else if (state == 'Pennsylvania' || state == 'PA') {
      rate = 0.06;
    } else if (state == 'Puerto Rico' || state == 'PR') {
      rate = 0.105;
    } else if (state == 'Rhode Island' || state == 'RI') {
      rate = 0.07;
    } else if (state == 'South Carolina' || state == 'SC') {
      rate = 0.06;
    } else if (state == 'South Dakota' || state == 'SD') {
      rate = 0.04;
    } else if (state == 'Tennessee' || state == 'TN') {
      rate = 0.07;
    } else if (state == 'Texas' || state == 'TX') {
      rate = 0.0625;
    } else if (state == 'Utah' || state == 'UT') {
      rate = 0.0595;
    } else if (state == 'Vermont' || state == 'VT') {
      rate = 0.06;
    } else if (state == 'Virginia' || state == 'VA') {
      rate = 0.053;
    } else if (state == 'Washington' || state == 'WA') {
      rate = 0.065;
    } else if (state == 'West Virginia' || state == 'WV') {
      rate = 0.06;
    } else if (state == 'Wisconsin' || state == 'WI') {
      rate = 0.05;
    } else if (state == 'Wyoming' || state == 'WY') {
      rate = 0.04;
    } else {
      rate = 0;
    }

    return (total * rate).toFixed(2);
  },
  calculateShippingByQuantity(quantity, total, isExpress) {
    if(this.getKiosk()!=null){
      return 0;
    }
    if (isExpress == true) {
      //domestic express
      return 15;
    } else {
      if (total >= 50) {
        return 0;
      }

      if (quantity <= 5) {
        return 4.9;
      } else if (quantity <= 8) {
        return 6.8;
      } else if (quantity <= 12) {
        return 8.6;
      } else if (quantity < 20) {
        return 9.3;
      } else if (quantity < 50) {
        return 16.8;
      } else if (quantity < 100) {
        return quantity * 0.28;
      } else if (quantity < 500) {
        return quantity * 0.26;
      } else if (quantity < 2000) {
        return quantity * 0.24;
      } else {
        return quantity * 0.24;
      }
    }
  },

  calculateShippingByQuantity_International(quantity, country, isExpress) {
    if(this.getKiosk()!=null){
      return 0;
    }
    if (isExpress == true) {
      // international express
      return 25;
    } else {
      if (country == 'CA') {
        if (quantity <= 7) {
          return 6.9;
        } else if (quantity <= 9) {
          return 9.9;
        } else if (quantity <= 12) {
          return 14.3;
        } else {
          return 25;
        }
      } else if (country == 'AU') {
        if (quantity <= 7) {
          return 9.9;
        } else if (quantity <= 9) {
          return 12.1;
        } else if (quantity <= 12) {
          return 14.3;
        } else {
          return 25;
        }
      } else {
        if (quantity <= 7) {
          return 12.00;
        } else if (quantity <= 9) {
          return 18.80;
        } else if (quantity <= 12) {
          return 18.80;
        } else {
          return 25.00;
        }
      }
    }
  },

  calculatetotalprice(list) {
    //base on current store.skuquantitylist.selectedsku
    // 1. calculate total price
    // 2. return total number of trackers
    // 3. return total number of hubs
    // 4. return a paypal itemlist object
    var total = 0;
    var totaltracker = 0;
    var totalhub = 0;
    var totalitem = 0;
    var itemlist = [];

    for (var i = 0; i < list.length; i++) {
      var object = list[i];
      if (object.sku == null || object.quantity == null) {
        continue;
      }
      total += object.sku.price * object.quantity;
      var name = "Truthbrush";
      if (object.sku.productid == 'prod_0001') {
        totaltracker += object.quantity;
        name += " Tracker (" + object.sku.attributes.Style + ")";
      } else if (object.sku.productid == 'prod_0003') {
        totaltracker += object.quantity;
        name += " Tracker Pro" + this.freeskinname() + " (" + object.sku.attributes.Style + ")";
      } else if (object.sku.productid == 'prod_0004') {
        totaltracker += object.quantity;
        name += " Tracker Tracker w 1 Yr Extended Battery (" + object.sku.attributes.Style + ")";
      } else if (object.sku.productid == 'prod_0002') {
        totalhub += object.quantity;
        name += " Hub";
      } else if (object.sku.productid == 'prod_0000') {
        name += " Tracker Skin (" + object.sku.attributes.Style + ")";
      } else {
        name += " " + object.sku.productname + " (" + object.sku.attributes.Style + ")"
      }

      itemlist.push({
        name: name,
        sku: object.sku.id,
        quantity: object.quantity,
        price: (object.sku.price / 100.0).toFixed(2),
        currency: "USD"
      })

      totalitem += object.quantity;
    }
    return [total, totaltracker, totalhub, itemlist, totalitem];
  },

  calculateBundleDiscount(bundle, apply_coupon, optional_list) {
    var coupon_percent_off = 0;
    if (apply_coupon) {
      coupon_percent_off = store.state.discount_percent;
    }

    var res = this.calculatetotalprice(store.state.skuquantitylist.selectedsku);
    if (optional_list != null) {
      res = this.calculatetotalprice(optional_list);
    }
    var total_count = res[1];
    var base_sum = res[0];

    var trackerdiscount = 100;

    if (total_count <= 1) {
      trackerdiscount = 100;
    } else if (total_count <= 2) {
      trackerdiscount = 100;
    } else if (total_count <= 3) {
      trackerdiscount = 100;
    } else if (total_count <= 4) {
      trackerdiscount = 100;
    } else {
      trackerdiscount = 100;
    }

    var bundled_sum = base_sum;
    if (bundle) {
      bundled_sum = base_sum * trackerdiscount / 100.0;
    }
    if (coupon_percent_off != null && coupon_percent_off > 0) {
      bundled_sum = base_sum * Math.floor(trackerdiscount * (1 - coupon_percent_off)) / 100.0
    }
    return (bundled_sum / 100.0).toFixed(2);

  },

  updateStripeButton(element, caller_context) {
    var stripe = caller_context.stripe;
    caller_context.order = null;
    var this_context = this;
    var paymentRequest = stripe.paymentRequest({
      country: 'US',
      currency: 'usd',
      total: {
        label: 'Your Order',
        amount: 0,
      },
      requestPayerName: true,
      requestPayerEmail: true,
      requestShipping: true,
      wallets: ["applePay"]

    });

    var elements = stripe.elements();
    var prButton = elements.create('paymentRequestButton', {
      paymentRequest: paymentRequest,
      style: {
        paymentRequestButton: {
          type: 'buy',
          // One of 'default', 'book', 'buy', or 'donate'
          // Defaults to 'default'

          theme: 'dark',
          // One of 'dark', 'light', or 'light-outline'
          // Defaults to 'dark'

          height: '40px'
          // Defaults to '40px'. The width is always '100%'.
        },
      },
    });

    // Check the availability of the Payment Request API first.
    paymentRequest.canMakePayment().then(function (result) {
      if (result) {
        // alert('mount')
        prButton.mount('#stripe_button_container');
      } else {
        var stripe_elem = document.getElementById('stripe_button_container');
        if (stripe_elem != null) {
          document.getElementById('stripe_button_container').style.display = 'none';
        }

      }
    });

    paymentRequest.on('token', function (ev) {

      var object = {};
      object.line1 = ev.shippingAddress.addressLine.join(", ");
      object.city = ev.shippingAddress.city;
      object.state = ev.shippingAddress.region;
      object.country = ev.shippingAddress.country;
      object.postal_code = ev.shippingAddress.postalCode;
      object.email = ev.payerEmail
      object.name = ev.payerName;
      var singleskus = {};
      for (var i = 0; i < store.state.skuquantitylist.selectedsku.length; i++) {
        singleskus[
          store.state.skuquantitylist.selectedsku[i].sku.id
        ] = store.state.skuquantitylist.selectedsku[i].quantity;
      }
      if(this_context.getKiosk()!=null){
        singleskus[KIOSK_SKU_ID] = 1;
      }

      object.singleskus = singleskus;
      var couponid = this_context.getCoupon();
      if (couponid != null) {
        object.coupon = couponid;
        //console.log("use coupon id:"+couponid)
      }
      //console.log("coupon id:"+couponid)

      captureOrderToken(object, ev.token.id)
        .then(function (res) {
          caller_context.order = res.data;
          this_context.clearCart();
          //caller_context.$refs.header.updateCart();
          caller_context.$store.orderpaid = res.data;
          caller_context.$store.orderform = caller_context.form;
          caller_context.$store.ordertoken = ev.token;

          var orderinfo = {};
          orderinfo.orderid = caller_context.order.id;

          if (couponid != null) {
            orderinfo.coupon = couponid;
          }
          //console.log("order info coupon:"+ orderinfo.coupon);

          orderinfo.ordertype = "stripe";
          orderinfo.email = ev.payerEmail;
          orderinfo.shipping = JSON.stringify(ev.shippingAddress);
          orderinfo.description = JSON.stringify(caller_context.order.items);
          orderinfo.orderprice = caller_context.order.amount;

  
          try{
            var fn = ev.shippingAddress.recipient.split(" ")[0]
            var ln = ev.shippingAddress.recipient.split(" ")[1]
            this_context.initExtended(orderinfo.email, fn, ln, null, ev.shippingAddress.city, ev.shippingAddress.region, ev.shippingAddress.postalCode, ev.shippingAddress.country)
          }catch(e){console.log()}
          this_context.reportPurchase(orderinfo.orderprice/100.0);

          try {
            submitOrderInfo(orderinfo)
              .then(() => {
                //console.log("order info ok:" + res);
              })
              .catch(function () {
                //console.log("order info failed:" + err);
              });

            /*
            sendEmailReceipt(orderinfo.orderid, {}).then(() => {
              //console.log("order info ok:" + res);
            }).catch(function () {
              //console.log("order info failed:" + err);
            })
            */
           
          } catch (err) {
            console.log(err)
          }

          /*
          if (caller_context != null && caller_context.$refs["my-modal"] != null) {
            caller_context.$refs["my-modal"].hide();
          }
          */

          setTimeout(function () {
            window.location.href = "/#/";
          }, 3000);
          ev.complete('success');


        })
        .catch(function () {
          ev.complete('fail');
        });
    });

    paymentRequest.on('shippingaddresschange', function (ev) {
      var object = {};
      object.line1 = ev.shippingAddress.addressLine.join(", ");
      object.city = ev.shippingAddress.city;
      object.state = ev.shippingAddress.region;
      object.country = ev.shippingAddress.country;
      object.postal_code = ev.shippingAddress.postalCode;
      object.email = "to_be_added"
      object.name = "to_be_added";
      var singleskus = {};
      for (var i = 0; i < store.state.skuquantitylist.selectedsku.length; i++) {
        singleskus[
          store.state.skuquantitylist.selectedsku[i].sku.id
        ] = store.state.skuquantitylist.selectedsku[i].quantity;
      }
      if(this_context.getKiosk()!=null){
        singleskus[KIOSK_SKU_ID] = 1;
      }
      object.singleskus = singleskus;
      var couponid = this_context.getCoupon();
      if (couponid != null) {
        object.coupon = couponid;
      }

      submitNewOrder(object)
        .then((res) => {
          this_context.reportInitCheckout((res.data.amount / 100.0).toFixed(2))
          this_context.reportAddPayment();



          var label = "";
          var amount = 0;
          caller_context.order = res.data;
          var PaymentItemArr = [];
          for (var i = 0; i < res.data.items.length; i++) {
            var obj = res.data.items[i];
            let item = {};
            item.amount = obj.amount;
            item.label = obj.description
            PaymentItemArr.push(item);
            if (obj.type == 'shipping') {
              label = obj.description;
              amount = obj.amount;
              break;
            }
          }
          var options = [
            // The first shipping option in this list appears as the default
            // option in the browser payment interface.
            {
              id: 'free-shipping 2',
              label: label,
              detail: "Fulfilled by truthbrush.com",
              amount: amount,
            },
          ]
          ev.updateWith({
            status: 'success',
            total: {
              label: 'Your Order',

              amount: res.data.amount,
            },
            displayItems: PaymentItemArr,
            shippingOptions: options
          });

        })
        .catch(function () {
          ev.updateWith({ status: 'invalid_shipping_address' });

        });
    });
  },

  updatePayPayButton(element, caller_context) {
    //console.log(2)

    var context = this;

    var FUNDING_SOURCES = [window.paypal.FUNDING.PAYPAL];
    //console.log(FUNDING_SOURCES)
    // Loop over each funding source / payment method
    FUNDING_SOURCES.forEach(function () {
      // Initialize the buttons
      window.paypal.Button.render({
        // Configure environment
        env: 'production',
        client: {
          sandbox: 'AUx-KqcROyXWPOXnqCpF1VZpdJrwfP_yvcsJOcQMDHJNO2Pq6ANmIF-WLFXkjt_H-bv9PsLAJDDh0x3X',
          production: 'AWUgRFc0nEW12AaTo-ebhlb0ufbIIhI3w-FL2G1FGo4hPTkfnYNufBtPUWZUUzhsDy6TWebKwmSiPWNf'
        },
        // Customize button (optional)
        locale: 'en_US',
        style: {
          size: "responsive",
          layout: 'horizontal',
          color: 'gold',
          shape: 'rect',
          tagline: false,
          height: 40
        },
        funding: {
          allowed: []
        },

        // Enable Pay Now checkout flow (optional)
        commit: true,

        // Set up a payment
        payment: function (data, actions) {
          var baseOrderAmount = 0;

          var cart = context.calculatetotalprice(store.state.skuquantitylist.selectedsku);
          baseOrderAmount = (cart[0] / 100.0).toFixed(2);

          var totalwithdiscount = context.calculateBundleDiscount(true, true)
          var discount = (baseOrderAmount - totalwithdiscount).toFixed(2);
          var shipping = context.calculateShippingByQuantity(cart[4], totalwithdiscount);
          shipping = shipping.toFixed(2)
          //console.log(discount)
          //console.log(baseOrderAmount - discount)


          context.reportInitCheckout(totalwithdiscount)
          context.reportAddPayment();
          //console.log('inside paypal:'+JSON.stringify(cart[3], null, 4)+" "+cart[3].length)
          if(context.getKiosk()!=null){
            
            var obj = {};
            obj.name = "Kiosk Pick Up";
            obj.sku = KIOSK_SKU_ID;
            obj.price = "0";
            obj.quantity = 1;
            obj.currency = 'USD'
            cart[3].push(obj);
            console.log('add free kiosk sku:'+JSON.stringify(cart[3], null, 4)+" "+cart[3].length)
          }
          
          return actions.payment.create({
            transactions: [{
              amount: {
                total: (parseFloat(baseOrderAmount) + parseFloat(shipping) - parseFloat(discount)).toFixed(2),
                currency: 'USD',
                details: {
                  subtotal: baseOrderAmount,
                  shipping: shipping,
                  shipping_discount: discount,
                }
              },
              description: "Your Truthbrush Order",
              item_list: { items: cart[3] }
            }]
          });
        },
        onShippingChange: function (data, actions) {
          var shipping = 0;

          var baseOrderAmount = 0;

          var cart = context.calculatetotalprice(store.state.skuquantitylist.selectedsku);
          baseOrderAmount = (cart[0] / 100.0).toFixed(2);

          var totalwithdiscount = context.calculateBundleDiscount(true, true)
          var discount = (baseOrderAmount - totalwithdiscount).toFixed(2);
          var tax = 0.00;
          if (data.shipping_address.country_code !== 'US') {
            shipping = context.calculateShippingByQuantity_International(cart[4], data.shipping_address.country_code);
          } else {
            shipping = context.calculateShippingByQuantity(cart[4], totalwithdiscount);
            tax = context.calculatetax(data.shipping_address.state, totalwithdiscount);
          }
          shipping = shipping.toFixed(2)

          return actions.order.patch([
            {
              op: 'replace',
              path: '/purchase_units/@reference_id==\'default\'/amount',
              value: {
                currency_code: 'USD',
                value: (parseFloat(baseOrderAmount) + parseFloat(shipping) + parseFloat(tax) - parseFloat(discount)).toFixed(2),
                breakdown: {
                  item_total: {
                    currency_code: 'USD',
                    value: baseOrderAmount
                  },
                  shipping: {
                    currency_code: 'USD',
                    value: shipping
                  },
                  shipping_discount: {
                    currency_code: 'USD',
                    value: discount
                  },
                  tax_total: {
                    currency_code: 'USD',
                    value: tax
                  },
                }
              }
            }
          ]);
        },
        // Execute the payment
        onAuthorize: function (data, actions) {
          return actions.payment.execute().then(function (details) {

            try{
              var shipping = details.payer.payer_info.shipping_address;
              context.initExtended(
                details.payer.payer_info.email,
                details.payer.payer_info.first_name,
                details.payer.payer_info.last_name, 
                null,
                shipping.city, 
                shipping.state, 
                shipping.postal_code, 
                shipping.country_code)
            }catch(e){console.log()}
            context.reportPurchase(details.transactions[0].amount.total)
            //console.log(details);
            try {

              /* post orderinfo  */
              var orderinfo = {};
              orderinfo.orderid = details.id;
              orderinfo.coupon = context.getCoupon();
              orderinfo.ordertype = "paypal";
              orderinfo.email = details.payer.payer_info.email;
              orderinfo.shipping = JSON.stringify(details.payer)
              orderinfo.description = JSON.stringify(details)
              orderinfo.orderprice = parseInt(details.transactions[0].amount.total * 100)
              submitOrderInfo(orderinfo).then(() => {
                //console.log("order info ok:" + res);
              }).catch(function () {
                //console.log("order info failed:" + err);
              })

              // prepare send email receipt for paypal
              var orderpaypalinfo = {};
              orderpaypalinfo.state = details.state;
              orderpaypalinfo.total = details.transactions[0].amount.total;
              orderpaypalinfo.tax = details.transactions[0].amount.details.tax;
              orderpaypalinfo.shipping = details.transactions[0].amount.details.shipping;
              orderpaypalinfo.discount = details.transactions[0].amount.details.shipping_discount;
              orderpaypalinfo.orderid = details.id;
              orderpaypalinfo.email = details.payer.payer_info.email;
              orderpaypalinfo.fname = details.payer.payer_info.first_name;
              orderpaypalinfo.lname = details.payer.payer_info.last_name;
              orderpaypalinfo.shipping_address_city = details.payer.payer_info.shipping_address.city;
              orderpaypalinfo.shipping_address_country_code = details.payer.payer_info.shipping_address.country_code;
              orderpaypalinfo.shipping_address_line1 = details.payer.payer_info.shipping_address.line1;
              orderpaypalinfo.shipping_address_line2 = details.payer.payer_info.shipping_address.line2;
              orderpaypalinfo.shipping_address_postal_code = details.payer.payer_info.shipping_address.postal_code;
              orderpaypalinfo.shipping_address_recipient_name = details.payer.payer_info.shipping_address.recipient_name;
              orderpaypalinfo.shipping_address_state = details.payer.payer_info.shipping_address.state;

              var skus = {};
              for (var i = 0; i < store.state.skuquantitylist.selectedsku.length; i++) {
                var s = store.state.skuquantitylist.selectedsku[i];
                skus[s.sku.id] = s.quantity;
              }

              if(context.getKiosk()!=null){
                skus[KIOSK_SKU_ID] = 1;
              }

              orderpaypalinfo.items = skus;
              sendEmailReceipt(null, orderpaypalinfo).then(() => {
                //console.log("order info ok:" + res);
              }).catch(function () {
                //console.log("order info failed:" + err);
              })
              //console.log(orderpaypalinfo);
            } catch (err) {
              console.log(err)
            }



            setTimeout(function () {
              window.location.href = "/#/ConfirmPayPal?c=" + encodeURIComponent(JSON.stringify(details));
            }, 2000);

            // This function shows a transaction success message to your buyer.

            if (caller_context != null && caller_context.$refs["my-modal"] != null) {
              caller_context.$refs["my-modal"].hide();
            }

          });
        }
      }, '#paypal_button_container');

    });
  }
}